import { render, staticRenderFns } from "./ThumbnailImageUploader.vue?vue&type=template&id=4d907136&scoped=true&lang=pug"
import script from "./ThumbnailImageUploader.vue?vue&type=script&lang=ts"
export * from "./ThumbnailImageUploader.vue?vue&type=script&lang=ts"
import style0 from "./ThumbnailImageUploader.vue?vue&type=style&index=0&id=4d907136&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d907136",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VCardText,VIcon})
